import i18n from "../../../../i18n";

export const primarySubtag = (tag: string): string =>
  tag.toLowerCase().split("-")[0];

/**
 * Picks the tag matching the language the admin is viewing PAM in. Resolved at
 * call time, not module load: the i18n language is applied after modules
 * evaluate.
 *
 * Exact tag wins over the primary subtag so a `pt-BR` admin prefers a `pt-BR`
 * tag over a `pt` one; the subtag pass covers casing and region drift between
 * i18n and the payload (`pt-br`, `en-NG`).
 */
export function matchActiveLanguageTag(tags: string[]): string | undefined {
  const active = i18n.resolvedLanguage || i18n.language;
  if (!active) return undefined;

  return (
    tags.find((tag) => tag.toLowerCase() === active.toLowerCase()) ??
    tags.find((tag) => primarySubtag(tag) === primarySubtag(active))
  );
}
